import { useTheme } from '@mui/material/styles';
import Button from '@mui/material/Button';
import Typography from '@mui/material/Typography';
import ArrowDropDownIcon from '@mui/icons-material/ArrowDropDown';
import ArrowDropUpOutlinedIcon from '@mui/icons-material/ArrowDropUpOutlined';
import { MultiselectOption } from '@cbo/shared-library';
import { defaultButtonStyling, selectedButtonStyling, arrowStyling } from '../GlobalFilterBarStyles';
import ButtonResetIcon from '../ButtonResetIcon';

interface MultiselectButtonProps {
  setAnchorEl: React.Dispatch<React.SetStateAction<HTMLButtonElement | null>>;
  anchorEl: HTMLButtonElement | null;
  defaultChecked: boolean | undefined;
  optionsLength: number;
  pluralName: string;
  controllerName: string;
  singularName: string;
  selected: MultiselectOption[];
  buttonSize: 'small' | 'medium' | 'large' | undefined;
  handleReset: () => void;
}

function MultiselectButton({
  setAnchorEl,
  anchorEl,
  defaultChecked,
  controllerName,
  optionsLength,
  pluralName,
  singularName,
  selected,
  buttonSize,
  handleReset,
}: MultiselectButtonProps) {
  const theme = useTheme();

  const handleButtonClick = (event: React.MouseEvent<HTMLButtonElement>) => {
    setAnchorEl(event.currentTarget);
  };
  const open = Boolean(anchorEl);

  const selectedButtonString = selected.length !== 1 ? `${selected.length} ${pluralName}` : `${selected[0].label}`;

  const resetValue =
    (selected.length > 0 && !defaultChecked) ||
    (selected.length < optionsLength && selected.length > 0 && defaultChecked);

  const handleButtonSx = () =>
    resetValue ? selectedButtonStyling(anchorEl, theme) : defaultButtonStyling(anchorEl, theme);

  if (resetValue) {
    return (
      <Button
        role='button'
        aria-haspopup='true'
        onClick={handleButtonClick}
        sx={handleButtonSx}
        size={buttonSize}
        data-testid={`${controllerName}-multiselect-button`}
        aria-label={`${singularName}, ${selectedButtonString}, selected`}
      >
        <Typography
          sx={{ marginRight: '8px', marginLeft: '12px', fontWeight: 500, lineHeight: '22px' }}
          fontSize='inherit'
        >
          {selectedButtonString}
        </Typography>
        <ButtonResetIcon handleReset={handleReset} />
      </Button>
    );
  }
  return (
    <Button
      role='button'
      aria-haspopup='true'
      onClick={handleButtonClick}
      sx={handleButtonSx}
      size={buttonSize}
      data-testid={`${controllerName}-multiselect-button`}
      aria-label={`${singularName}, ${selectedButtonString}, selected`}
    >
      <Typography
        sx={{ marginRight: '8px', marginLeft: '12px', fontWeight: 500, lineHeight: '22px' }}
        fontSize='inherit'
      >
        {singularName}
      </Typography>
      {open ? (
        <ArrowDropUpOutlinedIcon sx={arrowStyling(theme, false)} fontSize='inherit' />
      ) : (
        <ArrowDropDownIcon sx={arrowStyling(theme, false)} fontSize='inherit' />
      )}
    </Button>
  );
}

export default MultiselectButton;
